import Box from 'components/shared/Box'
import Checkbox from 'components/shared/Checkbox'
import Password from 'components/shared/Input/password'
import Section from 'components/shared/Section'
import Text from 'components/shared/Text'
import { FormattedMessage, useIntl } from 'react-intl'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import {
    RegisterField,
    setRegisterInfo,
    toggleOrderInfoAdditionalModule,
} from 'store/order-slice'
import styled from 'styled-components'
import { respondAbove } from 'styles/mediaQueries'
import { useErrorMessages } from 'utils/hooks/useErrorMessages'

const InputWrapper = styled(Box)`
    @media ${respondAbove.xl} {
        max-width: 390px;
    }
`

const CreateAccount = () => {
    const { isChecked, password } = useAppSelector(
        (state) => state.order.register
    )
    const { formatMessage } = useIntl()
    const dispatch = useAppDispatch()
    const { getError, handleRemoveError } = useErrorMessages()

    const handleInputChange = (field: RegisterField, value: string) => {
        dispatch(setRegisterInfo({ field, value }))
    }

    const toggleRegisterInfo = () => {
        if (isChecked) {
            handleInputChange('password', '')
        }

        dispatch(
            toggleOrderInfoAdditionalModule({
                field: 'register',
                isChecked: !isChecked,
            })
        )

        handleRemoveError('password')
    }

    return (
        <Section>
            <Box direction="row" mb={[24, 40]}>
                <Text variant="heading2" color="grayscale_900">
                    <FormattedMessage
                        id="order.account.section_caption"
                        defaultMessage="Utwórz konto"
                    />
                </Text>
            </Box>
            <InputWrapper gap={[24, 32]} isFullWidth>
                <Checkbox
                    isChecked={isChecked}
                    setIsChecked={toggleRegisterInfo}
                    testId="payment-check-create-account"
                >
                    <Text variant="body" color="grayscale_900">
                        <FormattedMessage
                            id="order.account.set_up_consent"
                            defaultMessage="Tak, chcę założyć konto"
                        />
                    </Text>
                </Checkbox>
                {isChecked && (
                    <Password
                        id="password"
                        placeholder={formatMessage({
                            defaultMessage: 'Wpisz hasło',
                            id: 'global.input.password_placeholder',
                        })}
                        infoMessage={formatMessage({
                            defaultMessage: 'Min. 8 znaków',
                            id: 'global.input.password_limitations',
                        })}
                        errorMessage={
                            password === ''
                                ? formatMessage({
                                      defaultMessage:
                                          'Pole nie może być puste.',
                                      id: 'global.input.error_empty_field',
                                  })
                                : formatMessage({
                                      defaultMessage:
                                          'Podane hasło jest niepoprawne',
                                      id: 'global.input.error_password_limitations',
                                  })
                        }
                        onBlur={(value) => handleInputChange('password', value)}
                        onChange={() => handleRemoveError('password')}
                        isError={!!getError('password')}
                        label={formatMessage({
                            defaultMessage: 'Hasło',
                            id: 'global.input.password_label',
                        })}
                        testId="payment-field-account-password"
                    />
                )}
            </InputWrapper>
        </Section>
    )
}
export default CreateAccount
